import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, UnstyledButton } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';

import { getAllArtifacts, getArtifact, useArtifactSwitch } from '@/artifacts';
import { useMapViewMode } from '@/hooks/useMapViewMode';

import styles from './ArtifactSwitcher.module.css';

const ICON_SIZE = 16;
const CHEVRON_SIZE = 14;

export const ArtifactSwitcher = memo(function ArtifactSwitcher() {
  const { t } = useTranslation();
  const { artifact: activeArtifactId } = useMapViewMode();
  const { navigateToArtifact } = useArtifactSwitch();

  const activeArtifact = getArtifact(activeArtifactId);
  if (!activeArtifact) return null;

  const ActiveIcon = activeArtifact.icon;

  return (
    <Menu
      shadow="md"
      position="bottom-start"
      offset={4}
      transitionProps={{ transition: 'pop-top-left' }}
    >
      <Menu.Target>
        <UnstyledButton
          className={styles.target}
          aria-label={t('appShell.artifactSwitcher.label')}
        >
          <ActiveIcon size={ICON_SIZE} />
          <span className={styles.label}>{t(activeArtifact.labelKey)}</span>
          <IconChevronDown size={CHEVRON_SIZE} className={styles.chevron} />
        </UnstyledButton>
      </Menu.Target>

      <Menu.Dropdown>
        {getAllArtifacts().map((artifact) => {
          const isActive = artifact.id === activeArtifact.id;
          const ItemIcon = artifact.icon;
          return (
            <Menu.Item
              key={artifact.id}
              leftSection={<ItemIcon size={ICON_SIZE} />}
              disabled={isActive}
              onClick={() => navigateToArtifact(artifact)}
            >
              {t(artifact.labelKey)}
            </Menu.Item>
          );
        })}
      </Menu.Dropdown>
    </Menu>
  );
});
